import { CategoryMetadata } from '../schema/CategoryMetadata';
import { getCategoryMetadataFromCategory } from '../internal/getCategoryMetadataFromCategory';
import { getMasterCategoriesFromUserConfig } from '../utils/getMasterCategoriesFromUserConfig';

/**
 * This function returns the initial categories lookup by creating a mapping of the categoryname to its metadata so as to help in a faster lookup later on
 */
export const getInitialCategoriesLookup = () => {
    const lookup = new Map<string, CategoryMetadata>();
    getMasterCategoriesFromUserConfig().forEach(category => {
        lookup.set(category?.Name, getCategoryMetadataFromCategory(category));
    });
    return lookup;
};
